"use client";

import { useEffect } from "react";
import { REF_COOKIE } from "@/lib/referral-shared";
import { getDeviceFingerprint } from "@/lib/fingerprint";

/** Tracks ?ref= parameter on page load — saves to cookie and calls track API */
export function RefTracker() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref) return;

    // Save to cookie (90 days)
    document.cookie = `${REF_COOKIE}=${ref}; path=/; max-age=${90 * 24 * 60 * 60}; SameSite=Lax`;

    // Track the click with device fingerprint
    getDeviceFingerprint()
      .then((fingerprint) =>
        fetch("/api/referral/track", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ slug: ref, fingerprint }),
        })
      )
      // intentional: best-effort referral telemetry; ref cookie persists 90d so attribution survives track-fail
      .catch(() => {});

    // Clean URL
    params.delete("ref");
    const clean = params.toString();
    const newUrl = window.location.pathname + (clean ? `?${clean}` : "");
    window.history.replaceState(null, "", newUrl);
  }, []);

  return null;
}
